import { Link as MaterialLink, type LinkProps as MaterialLinkProps } from '@mui/material'
import { forwardRef, useMemo } from 'react'
import { type LinkProps, useLocation } from 'react-router-dom'
import { Link } from '@/helpers/Link'

//	///////////////////////
//	MARK: EXPORTS
export type TLinkRouterProps = MaterialLinkProps &
  LinkProps & {
    keepSearch?: boolean
  }

//	///////////////////////
//	MARK: EXPORTS
export const LinkRouter = forwardRef<HTMLAnchorElement, TLinkRouterProps>(
  ({ keepSearch, ...props }, ref) => {
    const location = useLocation()

    const to = useMemo(() => {
      if (keepSearch) {
        let search: URLSearchParams | null = null

        search =
          typeof props.to === 'string'
            ? new URLSearchParams(props.to.split('?')[1])
            : new URLSearchParams(props.to.search)

        for (const [k, v] of new URLSearchParams(location.search).entries()) {
          search.append(k, v)
        }

        return typeof props.to === 'string'
          ? `${props.to.split('?')[0]}?${search.toString()}`
          : {
              ...props.to,
              search: search.toString(),
            }
      }

      return props.to
    }, [keepSearch, location.search, props.to])

    return <MaterialLink component={Link} ref={ref} {...props} to={to} />
  },
)
